const isValidHttpUrl = (urlStr) => {
    let url;

    try {
        url = new URL(urlStr);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

export {
    isValidHttpUrl
};